import { ACTION_PLAN_STATUS } from '../../common/utils'
import i18n from 'live/services/i18n'
export function getAnalysisWithFieldsThatMatchTheFilter(
    searchFilter: string,
    analysisResults: AnalysisEvent[]
): AnalysisEvent[] {
    if (searchFilter) {
        return analysisResults.filter(analysis => {
            const { sku, analysisCreator, country, factory, line, batch, analysisType } = analysis
            const values = [sku, batch, analysisCreator, country, factory, line, i18n(analysisType), analysisType]
            const matches = values.filter(value => value?.toLowerCase()?.includes(searchFilter.toLowerCase()))
            if (matches.length) return true
        })
    } else {
        return analysisResults
    }
}

export function getAnalysisByActionPlanStatus(
    analysisResults: AnalysisEvent[],
    selectedStatus: ActionPlanStatusFilter
): AnalysisEvent[] {
    if (selectedStatus === 'all') return analysisResults

    return analysisResults.filter(analysis => {
        const { actionPlans } = analysis

        if (!actionPlans) return false

        const actionPlansStatus = actionPlans.map(plan =>
            plan.planStatus ? ACTION_PLAN_STATUS.DONE : ACTION_PLAN_STATUS.PENDING
        )

        if (actionPlansStatus.includes(selectedStatus)) return true
    })
}
